import { render, staticRenderFns } from "./DetailKeringanan.vue?vue&type=template&id=55599d62&"
import script from "./DetailKeringanan.vue?vue&type=script&lang=js&"
export * from "./DetailKeringanan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports